module.exports = __webpack_public_path__ + "img/8.84e7d3cc.jpeg";